import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Table,
  Input,
  Button,
  Space,
  PageHeader,
  Breadcrumb,
  Tag,
  
  Select,
  Row,
  Col,
  Tooltip,
} from "antd";
import Highlighter from "react-highlight-words";
import { EditOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import { getClients, updateClientPassword } from "../../actions/clients";
import { getUsers, updateAuth, } from "../../actions/user";
import { Link } from "react-router-dom";
import history from "../../history";
import { connect } from "react-redux";
import { Pagination } from "antd";
import EditUnit from "./edit_unit";
import ChangePass from "./changePass";
const { Option } = Select;
class ClientList extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    data: [],
    serviceDetails: null,
    detail: false,
    visible: false,
    passVisible: false,
    modalVisible: false,
    editModalVisible: false,
    placement: "bottom",
    id: "",
    e: null,
    p: 1,
    au: null,
    a: null,
    b: null,
    current: 1,
  };

  componentDidMount = async () => {
    const res = await this.props.getClients(
      this.state.p,
      this.state.e,
      this.state.au,
      this.state.a,
      this.state.b
    );
    this.setState({ data: res });
  };

  handleStatus = async (user, active) => {
    const code = await this.props.updateAuth(user, active);
    if (code === 201) {
      const res = await this.props.getClients();
      this.setState({ data: res });
    }
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  createData = (
    sl,
    user_id,
    name,
    mobile_number,
    email,
    brand_name,
    authenticated,
    active_account,
    created_at,
    unit_cost,
    action
  ) => {
    return {
      sl,
      user_id,
      name,
      mobile_number,
      email,
      brand_name,
      authenticated,
      active_account,
      created_at,
      unit_cost,
      action,
    };
  };

  showDrawer = (id) => {
    this.setState({
      visible: true,
      id: id,
    });
  };
  handleRefresh = async () => {
    const res = await this.props.getClients();
    this.setState({ data: res });
  };

  handlePassVisible = (id) => {
    this.setState({ passVisible: true, id: id });
  };
  handleModalVisible = () => {
    this.setState({ modalVisible: !this.state.modalVisible });
  };
  handleVisible = async (client) => {
    history.push(`/client/client-details?client=${client}`);
  };

  handleEditModalVisible = (user_id) => {
    this.setState({
      editModalVisible: !this.state.editModalVisible,
      id: user_id,
    });
  };
  onClosePass = () => {
    this.setState({
      passVisible: false,
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  makeLocalTime = (date) => {
    let mainDate = date.split("T")[0];
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      mainDate + " , " + hours + ":" + minutes + " " + (am ? "a.m" : "p.m")
    );
  };

  handleDate = (date) => {
    if (date) {
      const ds = new Date(date[0]._d);
      const de = new Date(date[1]._d);
      this.setState({ ds: ds.toISOString(), de: de.toISOString() });
    } else {
      this.setState({ ds: null, de: null });
      return;
    }
  };
  handlePageChange = async (page) => {
    const res = await this.props.getClients(
      page,
      this.state.e,
      this.state.a,
      this.state.au,
      this.state.b
    );
    this.setState({ current: page, data: res });
  };
  handleApiSearch = async () => {
    const res = await this.props.getClients(
      this.state.p,
      this.state.e,
      this.state.a,
      this.state.au,
      this.state.b
    );
    this.setState({ data: res });
  };

  render() {
    const columns = [
      {
        title: "SL",
        dataIndex: "sl",
        key: "sl",
        width: "10%",
      },
      {
        title: "User ID",
        dataIndex: "user_id",
        key: "user_id",
        width: "15%",
        ...this.getColumnSearchProps("user_id"),
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "25%",
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "Mobile Number",
        dataIndex: "mobile_number",
        key: "mobile_number",
        width: "20%",
        ...this.getColumnSearchProps("mobile_number"),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "25%",
        ...this.getColumnSearchProps("email"),
      },
      {
        title: "Brand Name",
        dataIndex: "brand_name",
        key: "brand_name",
        width: "25%",
        ...this.getColumnSearchProps("brand_name"),
      },
      {
        title: "Status",
        dataIndex: "authenticated",
        key: "authenticated",
        width: "25%",
        ...this.getColumnSearchProps("authenticated"),
      },
      {
        title: "Account Status",
        dataIndex: "active_account",
        key: "active_account",
        width: "25%",
        ...this.getColumnSearchProps("active_account"),
      },
      {
        title: "Register Date",
        dataIndex: "created_at",
        key: "created_at",
        width: "25%",
        ...this.getColumnSearchProps("created_at"),
      },
      {
        title: "Unit Cost",
        dataIndex: "unit_cost",
        key: "unit_cost",
        width: "25%",
        ...this.getColumnSearchProps("unit_cost"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: "28%",
      },
    ];
    const { data, placement, visible, id, passVisible } = this.state;
    const rows = [
      data?.clients
        ? data?.clients?.map((item, id) =>
            this.createData(
              id + 1,
              item.user_id,
              item.name,
              item.mobile_number,
              item.email,
              item.brand_name,
              item.authenticated === false ? (
                <Tag color="#f01e1e">Unauthenticated</Tag>
              ) : (
                <Tag color="#2df893">Authenticated</Tag>
              ),
              item.active_account === false ? (
                <Tag color="#f01e1e">Deactive AC</Tag>
              ) : (
                <Tag color="#2df893">Active AC</Tag>
              ),
              this.makeLocalTime(item.created_at),

              <>
                {item?.unit_cost === null ? (
                  <>
                    <Button
                      size="small"
                      type="primary"
                      style={{ background:"#f01e1e" , }}
                      icon={<EditOutlined />}
                      onClick={() => this.handleEditModalVisible(item.user_id)}
                    >
                      Set Unit
                    </Button>
                    &nbsp;
                  </>
                ) : (
                  <>
                    {item.unit_cost} BDT &nbsp;
                    <Button
                      size="small"
                      type="primary"
                      icon={<EditOutlined />}
                      onClick={() => this.handleEditModalVisible(item.user_id)}
                    ></Button>
                    &nbsp;
                  </>
                )}
              </>,

              <>
                <Button
                  size="small"
                  type="primary"
                  icon={<EyeOutlined />}
                  onClick={() => this.handleVisible(item.user_id)}
                >
                  View
                </Button>
                &nbsp;
              </>
            )
          )
        : "",
    ];
    return (
      <Content >
        <Breadcrumb style={{ padding: "10px 0px" }}>
          <Breadcrumb.Item>
            <Link to="/dashboard">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Client List</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Client List"
          subTitle="Client Management"
          extra={
            <Tag style={{ fontSize: "15px", padding: "4px" }} color="#2db7f5">
              {" "}
              {data?.count} clients found
            </Tag>
          }
        ></PageHeader>
        <br />

        <Row>
          <Col xs={12} sm={8} md={6} lg={6} xl={6}>
            <Input
              placeholder="Client Email"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ e: e.target.value })}
            />
          </Col>
          <Col xs={12} sm={8} md={6} lg={6} xl={4}>
            <Input
              placeholder="Brand Name"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ b: e.target.value })}
            />
          </Col>
          <br />
          <br />
          <Col xs={12} sm={8} md={6} lg={6} xl={4}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select a status"
              name="status"
              optionFilterProp="children"
              onChange={(e) => this.setState({ a: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>
              <Option value="active">Active</Option>
              <Option value="inactive">Inactive</Option>
            </Select>
          </Col>
          <Col xs={12} sm={8} md={8} lg={8} xl={6}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select a status"
              name="status"
              optionFilterProp="children"
              onChange={(e) => this.setState({ au: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>
              <Option value="authorized">Authenticated</Option>
              <Option value="unauthorized">Unauthenticated</Option>
            </Select>
          </Col>
          &nbsp; &nbsp;
          <Tooltip title="search" onClick={this.handleApiSearch}>
            <Button type="primary" shape="circle" icon={<SearchOutlined />} />
          </Tooltip>
        </Row>
        <Table
          columns={columns}
          dataSource={rows[0]}
          scroll={{ x: 1000 }}
          sticky
          pagination={false}
        />
        <Pagination
          size="small"
          current={this.state.current}
          total={data?.count}
          pageSize="20"
          onChange={this.handlePageChange}
          pageSizeOptions={[20]}
        />

        <ChangePass
          placement={placement}
          visible={passVisible}
          fnc={this.onClosePass}
          id={id}
          passFnc={this.props.updateClientPassword}
          data={this.state.data}
          refresh={this.handleRefresh}
        />

        {/* <ModalForm visible={this.state.modalVisible} setVisible={this.handleModalVisible} refresh = {this.handleRefresh}/> */}

        {this.state.editModalVisible ? (
          <EditUnit
            visible={this.state.editModalVisible}
            setVisible={this.handleEditModalVisible}
            user_id={this.state.id}
            refresh={this.handleRefresh}
          />
        ) : null}
      </Content>
    );
  }
}

export default connect(null, {
  getClients,
  updateAuth,
  getUsers,
  updateClientPassword,
})(ClientList);
